var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSynergiesSortCustom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M2.851 1.293L.729 3.414M2.161 1.282l2.121 2.122M2.17 14.707l2.121-2.121M2.859 14.718L.738 12.597M2.5 1.517v13M16 11.017H6M6 8.017h5M5.999 5.017l7.572-.02"
  })));
}

export default SvgSynergiesSortCustom;